import React from 'react';
import Subtitle from '../subtitle/Subtitle';

import { Row, Col, Container } from 'reactstrap';
import EirButton from '../eir-button/EirButton';
import { isMobile, isTablet, isMobileOnly } from "react-device-detect";

function GeneralTile(props) {

  const renderContent = (content) => {
    return { __html: content };
  }

  return (

    <div className='general-tile mb-3'>
      <a aria-label={props.cta && props.cta.ariaLabel} href={ props.cta && props.cta.link}>
        {props.image && props.title &&
          <div>
            {props.image &&
              <div className="p-0 shadow-none">
                <div className="d-flex flex-column justify-content-center align-items-center">
                  <img className="w-100 mb-2 top-borders" src={props.image} alt={props.alt?props.alt:""} />
                </div>
              </div>
            }

            <div className='tile-content'>
              {!props.cta &&
                <div className='mb-0 p-2 ml-3  mr-3 three_six_titlearea' dangerouslySetInnerHTML={renderContent(props.title)} ></div>
              }
              {props.cta && props.cta.type != 'arrow' &&
                <div className='mb-0 p-2 ml-3  mr-3 three_six_titlearea' dangerouslySetInnerHTML={renderContent(props.title)} ></div>
              }
              {props.cta && props.cta.type == 'arrow' &&
                <div className="d-flex flex-row justify-content-center align-items-center">
                  <div className='mb-0 three_six_titlearea ' dangerouslySetInnerHTML={renderContent(props.title)} ></div>
                  <div className="mt-2">
                    <div className='arrow_cta  float-right mb-2 mr-3 shadow-none' id={props.id}></div>
                  </div>
                </div>
              }
              {props.text &&
                <Subtitle className='eir-text justify-content-center ml-3  mr-3 three_six_textarea pl-2 pr-2 text-body' text={props.text} />
              }

            </div>
            {props.cta && props.cta.type != 'arrow' &&
            <div className={(props.ctaAlignment=='centre')? 'd-flex justify-content-center align-items-center' : (isMobileOnly)? 'ml-3' : 'ml-4'}>
              <EirButton  {...props.cta} databundlecode={props.id}
                outline={true}
                className={(props.cta.type == 'button') ? "mt-3 float-left js-prequal-modal-btn eir-text-secondary ls-0 p-2 cta_threesix" : "mt-0 float-left js-prequal-modal-btn cta_threesix link_threesix ls-0"}
              />
            </div>

            }
          </div>
        }
      </a>
    </div>

  )
}
export default GeneralTile;